import AppMenu from './AppMenu'

export default function Header({ title }) {
  return (
    <>
      <div className="bg-cyan-800 dark:bg-gray-800 pb-32">
        <AppMenu />
        <header className="py-10">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold tracking-tight text-white">{title}</h1>
          </div>
        </header>
      </div>
    </>
  )
}

